import { setAccessToken } from '../../utilities/utils';
import ViewNewsModal from '../../shared/view-news/view-news-modal';

function NewsArticle() {
	const url = new URL(window.location.href);
	const token = window.atob(url.searchParams.get('t') ?? '');
	const articleId = window.atob(url.searchParams.get('a') ?? '');
	const provider = window.atob(url.searchParams.get('p') ?? '');
	const timestamp = window.atob(url.searchParams.get('ts') ?? '');
	const sideBar = document.getElementById('sideBar');
	if (sideBar) {
		sideBar.style.display = 'none';
	}
	setAccessToken(token);

	return (
		<div id={'news-article-page'}>
			<ViewNewsModal
				articleId={articleId}
				provider={provider}
				timeStamp={timestamp}
				isPageView={true}
			/>
		</div>
	);
}

export default NewsArticle;